import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import {Avatar, Backdrop, Button, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Divider, Grid, Link, Paper, TextField, Tooltip, Typography} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import CancelCircleOutline from '@mui/icons-material/Cancel';
import Email from '@mui/icons-material/Email';
import Lock from '@mui/icons-material/Lock';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';

import AbEnvironment from '../auth/AbEnvironment';
import AccountActivationUpdateMutation from './AccountActivationUpdateMutation';
import AccountUpdateMutation from '../account/AccountUpdateMutation';
import UserUpdateMutation from '../account/UserUpdateMutation';

import SavingSpinner from '../ui/SavingSpinner';

import { Client } from 'persona';

import { red, green, amber } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    paper: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
      // marginTop: 32,
      // paddingTop: 16,
      // paddingLeft: 10,
      // paddingRight: 10,
      // paddingBottom: 20,
      color: theme.palette.text.secondary,
    },
    inset : {
      paddingLeft: 32,
      paddingRight: 32,
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    icon: {
      marginRight: '32px',
      height: '2em',
      width: '2em'
    },
    continue: {
      marginBottom: '16px',
    }
});

class AccountActivationSteps extends Component {
    
  constructor(props) {
    super(props);

    this.state = {
      backdropOpen: true,
      personaLoading: false,
      templateId: null,
      environment: null,

      nameUpdateOpen: false,
      updateNameSpinner: false,
      uLastName: abEnvironment.getUserAttribute("a_lastName"),
      uFirstName: abEnvironment.getUserAttribute("a_firstName")

    }
  }

  componentDidMount() {

    const { callPartnerApi, logError } = this.props.auth;

    //fetch environment info and present window.
    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "getPersonaTemplateInfo",
      params: {
        pJwt: aPjwt
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      this.setState({templateId: response.templateId, environment: response.environment})

    })
    .catch(error => {
      logError('Exception in AccountActivationSteps.js: ' + error);
    });    

  }

  openPersona() {

    this.setState({personaLoading: true, updateNameSpinner: false});
    let email = abEnvironment.getUserAttribute("a_email");
    let firstName = abEnvironment.getUserAttribute("a_firstName");
    let lastName = abEnvironment.getUserAttribute("a_lastName");

    const client = new Client({
      templateId: this.state.templateId,
      environment: this.state.environment,
      fields: {
        nameFirst: firstName,
        nameLast: lastName,
        emailAddress: email
      },
      onLoad: (error) => {
        if (error) {
          console.error(`Failed with code: ${error.code} and message ${error.message}`)
        }
        client.open();
        this.setState({personaLoading: false});
      },
      onCancel: (inquiry) => {
        //console.log(`Cancelling, updating account with inquiry id`);
        this.updateAccountWithInquiryId(inquiry.inquiryId);
      },
      onComplete: (inquiry) => {
        //console.log(`Complete, calling backend`);
        this.updateAccountWithStatus(inquiry.inquiryId);
      }
    });

  }

  updateUserAndGo() {
    this.setState({ updateNameSpinner: true });
    const { uLastName, uFirstName } = this.state; 

    let aid = abEnvironment.getUserAttribute('a_id');
    let uid = abEnvironment.getUserAttribute('u_id');
    UserUpdateMutation.commit(uid,
                              uLastName, uFirstName, null, null,
                              null, null, null, null, null, null,
                              null)
    .then(response => {
      // Call an update mutation to set on the account
      return AccountUpdateMutation.commit(aid, null, null, null, null,
                                          uLastName, uFirstName, null, null,
                                          null, null, null, null, null, null,
                                          null, null, null, null, null,
                                          null, null, null);

      }).then(response => {
        abEnvironment.setUserAttribute('a_lastName', uLastName);
        abEnvironment.setUserAttribute('a_firstName', uFirstName);
        abEnvironment.setUserAttribute('u_lastName', uLastName);
        abEnvironment.setUserAttribute('u_firstName', uFirstName);

        // console.log('User Update');
        this.setState({ nameUpdateOpen: false });
        this.openPersona();
    })
    .catch(error => {
      // console.log('Got error: ' + error);
      this.setState({ updateNameSpinner: false });
    });
  }



  updateAccountWithInquiryId(inquiryId) {
 
    const { logError } = this.props.auth;

    let accountId = abEnvironment.getUserAttribute("a_id");

    AccountActivationUpdateMutation.commit(accountId, inquiryId)
    .then(response => {
      //console.log('update good: ' + inquiryId);
    })
    .catch(error => {
      logError('Exception in AccountActivationSteps.js: ' + error);
    });

  }

  updateAccountWithStatus(inquiryId) {

    const { logError } = this.props.auth;

    this.setState({personaLoading: true});

    let accountId = abEnvironment.getUserAttribute("a_id");
    let accountName = abEnvironment.getUserAttribute("a_accountName");
    let status = '';

    const { callPartnerApi } = this.props.auth;

    //fetch environment info and present window.
    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "getPersonaInquiryStatus",
      params: {
        pJwt: aPjwt,
        accountId: accountId,
        inqId: inquiryId
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {


      //console.log(response);
      //console.log(JSON.stringify(response));

      status = response.status;

      let theBody = accountName + ' completed verification process. Status is ' + status;


      let payload = {
        operation: "createNotification",
        params: {
          pJwt:             aPjwt,
          accountId:        accountId,
          notificationType: 'verification',
          severity:         'info',
          subject:          'Verification check',
          body:             theBody
        }
      }
      
      return callPartnerApi('appbind/generic',
                     'POST',
                     payload
      )
    })
    .then(response => {

      this.setState({personaLoading: false});

      //temporary code
      if (localStorage.getItem("verificationAuto") === "1") {
        if (status === 'passed') {
          abEnvironment.setUserAttribute('a_aStatus', 0);
        }
      }

      if (status === 'passed') {
        abEnvironment.setUserAttribute('a_personaStatus', 'passed');
      }

 
      window.location.reload();

    })
    .catch(error => {
      logError('Exception in AccountActivationSteps.js: ' + error);
    });    


    //window.location.reload();

  }


  updateAccountWithVerificationComplete() {
    const { logError } = this.props.auth;

    let accountId = abEnvironment.getUserAttribute("a_id");

    AccountActivationUpdateMutation.commit(accountId, null, 1)
    .then(response => {
      window.location.reload();
    })
    .catch(error => {
      logError('Exception in AccountActivationSteps.js: ' + error);

    });

  }

  /*goToPersona() {
    
    this.props.history.push("/persona");
  }*/

  handleClose()  {
    localStorage.setItem("activateSteps", true);
    this.setState({backdropOpen: false});
  }


  openNameUpdateDialog() {
    this.setState({nameUpdateOpen: true});
  }


  openNameUpdateDialogComplete() {
    this.updateUserAndGo();
  }


  handleNameUpdateDialogClose() {
    this.setState({nameUpdateOpen: false});
  }

  activateClick() {
    localStorage.removeItem("activateSteps");
    this.setState({backdropOpen: true})
  }
  render() {
      const classes = this.props.classes;
      const okColor = green[300];
      const failedColor = red[300];
      const statusWaiting = amber[400];
      const preventDefault = (event) => event.preventDefault();

      if ((this.props.accountType === 3) && (this.props.accountStatus === 1)) {
        //suspended reseller
        return (
          <Paper className={classes.paper} elevation={1} >
            <div >
              <Typography variant="h6">
                Suspended account
              </Typography>
              <Typography variant="body2">
                Your account has been suspended. You can review past activity, but cannot add customers, add funding sources, or purchase subscriptions through AppBind. Please contact support to learn how to recover your account.
              </Typography>
  
            </div>
  
          </Paper>
        );  

      } else if ((this.props.accountType === 3) && (this.props.accountStatus === 2 || this.props.accountStatus === 0) && (this.props.verificationComplete !== 1)) {

        let clickedOff = localStorage.getItem("activateSteps");

        if (!clickedOff && this.state.backdropOpen && this.props.accountStatus === 2 && this.props.personaStatus !== 'passed') {
          //pending reseller
          return (
            <Backdrop open={this.state.backdropOpen}  className={classes.backdrop} onClick={() => this.handleClose() }>
              <Paper className={classes.paper} elevation={1} >
                <div >
                  {this.props.accountStatus === 2 &&
                  <React.Fragment>
                     <Grid container spacing={0} direction="row" justifyContent="space-between" className={classes.inset}>
 
                      <Grid item>
                        <Typography variant="h6">
                          Activate your account.
                        </Typography>
                        <Typography variant="body2">
                          Welcome! Let’s get to know you a little better.
                        </Typography>
                        </Grid>
                      <Grid item>
                      <Grid container spacing={1} direction="row" style={{marginTop: '8px'}}>
                        {(this.props.accountStatus === 2 || this.props.accountStatus === "2") &&
                        <React.Fragment>
                          <Grid item>
                            <HourglassEmpty  htmlColor={statusWaiting}/>
                          </Grid>
                          <Grid item>
                            <Typography variant="body1">PENDING</Typography>
                          </Grid>
                        </React.Fragment>
                        }
                        {(this.props.accountStatus === 0 || this.props.accountStatus === "0") &&
                         <React.Fragment>
                          <Grid item>
                            <CheckCircle  htmlColor={okColor}/>
                          </Grid>
                          <Grid item>
                            <Typography variant="body1">ACTIVE</Typography>
                            </Grid>
                         </React.Fragment>
                         }
                      </Grid>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                  }
      
                  <Grid container spacing={2}  style={{marginTop: 16}}>
                    <Grid container spacing={2} direction="row" justifyContent="space-between">
                      <Grid item xs={12} style={{marginBottom: '16px'}}>
                        <Divider className={classes.divider}></Divider>
                      </Grid>
                      
                      <Grid item>
                        <Grid container spacing={0} direction="row">
                          <Grid item  className={classes.inset}>
                            <Avatar>
                              <Email />
                            </Avatar>
                          </Grid>
                          <Grid item >
                            <Typography variant="body1"><strong>Verify your email</strong></Typography>
                            <Typography variant="body2">{'Check your email'}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                          <CheckCircle htmlColor={okColor}  className={classes.icon} />
                      </Grid>
    
                      <Grid item xs={12} style={{marginBottom: '16px'}}>
                        <Divider></Divider>
                      </Grid>
                      <Grid item >

                        <Grid container spacing={0} direction="row">
                          <Grid item  className={classes.inset}>
                            <Avatar>
                              <VerifiedUser />
                            </Avatar>
                          </Grid>
                          <Grid item >
                              <Typography variant="body1"><strong>Verify your identity securely</strong></Typography>
                              <Typography variant="body2">{'Check your driver’s license or passport in less than 5 minutes.'}</Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item>
                        {this.props.personaStatus !== 'passed' && this.props.personaStatus !== 'failed' &&
                        <React.Fragment>
                          {this.state.personaLoading === false &&
                          <Button color="primary" variant={"contained"} disabled={false} style={{marginRight: '32px'}}
                              onClick={() => { this.openNameUpdateDialog(); }}>
                                Verify&nbsp;<Lock/>
                          </Button> 
                          }
                          {this.state.personaLoading === true &&

                          <Button disabled={true} color="primary" variant="outlined" >
                            <SavingSpinner/>
                          </Button> 
                          }
                          
                          </React.Fragment>
                        }
                        {this.props.personaStatus === 'passed' &&
                          <CheckCircle htmlColor={okColor} className={classes.icon}/>
                        }
                        {this.props.personaStatus === 'failed' &&
                          <Tooltip title='Your documents submitted failed verification.  Contact AppBind.'>
                            <CancelCircleOutline htmlColor={failedColor}  className={classes.icon}/>
                          </Tooltip>
                        }
                      </Grid>
    
                      
                      
                      <Grid item xs={12} style={{marginTop: '16px', marginBottom: '16px'}}>
                        <Divider></Divider>
                      </Grid>
 
                      <Grid item xs={12} className={classes.continue}>
                      <Grid container spacing={0} direction="row">
                          <Grid item style={{minWidth: 106}}>
                            
                          </Grid>
                          <Grid item >
                          <Typography variant="body1"><strong>Want to explore first?</strong> 
                            <Link href="#" onClick={preventDefault} style={{marginLeft: '8px', color: 'blue'}}>
                            Skip for now.
                            </Link> 
                          </Typography>
                          </Grid>
                        </Grid>
                          
                      </Grid>
                      

                    </Grid>

                  </Grid>  

                </div>

              </Paper>
            </Backdrop>
          );  
    
        } else {
          //active or pending reseller who either has not completed all steps or needs to dismiss / acknowledge
          return (
            <Paper className={classes.paper} elevation={1} >
            <div >
              {((this.props.accountStatus === 2) || (this.props.accountStatus === 0)) &&
              <React.Fragment>
                 <Grid container spacing={0} direction="row" justifyContent="space-between" className={classes.inset}>

                 {(this.props.accountStatus === 2) &&
                    <React.Fragment>
                      <Grid item>
                        <Typography variant="h6">
                          Activate your account.
                        </Typography>
                        <Typography variant="body2">
                          Welcome! Let’s get to know you a little better.
                        </Typography>
                        </Grid>
                      <Grid item>
                        <Grid container spacing={1} direction="row" style={{marginTop: '8px'}}>
                          <Grid item>
                            <HourglassEmpty  htmlColor={statusWaiting}/>
                          </Grid>
                          <Grid item>
                            <Typography variant="body1">PENDING</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  }
                {(this.props.accountStatus === 0) &&
                    <React.Fragment>
                      <Grid item>
                        <Typography variant="h6">
                          You are all set.
                        </Typography>
                        <Typography variant="body2">
                          Welcome to AppBind! Click close to dismiss.
                        </Typography>
                        </Grid>
                      <Grid item>
                        <Grid container spacing={1} direction="row" style={{marginTop: '8px'}}>
                          <Grid item>
                            <CheckCircle  htmlColor={okColor}/>
                          </Grid>
                          <Grid item>
                            <Typography variant="body1">ACTIVE</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  }

                </Grid>
              </React.Fragment>
              }
  
              <Grid container spacing={2}  style={{marginTop: 16}}>
                <Grid container spacing={2} direction="row" justifyContent="space-between">
                  <Grid item xs={12} style={{marginBottom: '16px'}}>
                    <Divider className={classes.divider}></Divider>
                  </Grid>
                  
                  <Grid item>
                    <Grid container spacing={0} direction="row">
                      <Grid item  className={classes.inset}>
                        <Avatar>
                          <Email />
                        </Avatar>
                      </Grid>
                      <Grid item >
                        <Typography variant="body1"><strong>Verify your email</strong></Typography>
                        <Typography variant="body2">{'Check your email'}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                      <CheckCircle htmlColor={okColor}  className={classes.icon} />
                  </Grid>

                  <Grid item xs={12} style={{marginBottom: '16px'}}>
                    <Divider></Divider>
                  </Grid>
                  <Grid item >

                    <Grid container spacing={0} direction="row">
                      <Grid item  className={classes.inset}>
                        <Avatar>
                          <VerifiedUser />
                        </Avatar>
                      </Grid>
                      <Grid item >
                          <Typography variant="body1"><strong>Verify your identity securely</strong></Typography>
                          <Typography variant="body2">{'Check your driver’s license or passport in less than 5 minutes.'}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item style={{marginBottom: '16px'}}>
                    {this.props.personaStatus !== 'passed' && this.props.personaStatus !== 'failed' &&
                      <React.Fragment>
                        {this.state.personaLoading === false &&
                        <Button color="primary" variant={"contained"} disabled={false} style={{marginRight: '32px'}}
                            onClick={() => { this.openNameUpdateDialog(); }}>
                                Verify&nbsp;<Lock/>
                        </Button> 
                        }
                        {this.state.personaLoading === true &&

                        <Button disabled={true} color="primary" variant="outlined" style={{marginRight: '32px'}} >
                          <SavingSpinner/>
                        </Button> 
                        }
                        
                      </React.Fragment>
                  }
                    {this.props.personaStatus === 'passed' &&
                      <CheckCircle htmlColor={okColor} className={classes.icon}/>
                    }
                    {this.props.personaStatus === 'failed' &&
                      <Tooltip title='Your documents submitted failed verification.  Contact AppBind.'>
                        <CancelCircleOutline htmlColor={failedColor}  className={classes.icon}/>
                      </Tooltip>
                    }
                  </Grid>

                  {((this.props.accountStatus === 2) && (this.props.personaStatus === 'passed')) &&

                  <React.Fragment>
                    <Grid item xs={12} style={{marginBottom: '16px'}}>
                      <Divider></Divider>
                    </Grid>
                    <Grid item xs={12} className={classes.continue}>
                      <Grid container spacing={0} direction="row">
                        <Grid item style={{minWidth: 106}}>
                          
                        </Grid>
                        <Grid item >
                          <Typography variant="body1"><strong>Thank you for verifying.</strong></Typography>
                          <Typography variant="body2">AppBind will review and activate your account.</Typography>
                        </Grid>
                      </Grid>
                        
                    </Grid>

                  </React.Fragment>
                  }



                  {((this.props.accountStatus === 0) && (this.props.verificationComplete === 0)) &&

                  <React.Fragment>
                    <Grid item xs={12} style={{marginBottom: '16px'}}>
                      <Divider></Divider>
                    </Grid>

                    <Grid item xs={12} className={classes.continue}>
                      <Grid container spacing={0} direction="row">
                        <Grid item style={{minWidth: 106}}>
                          
                        </Grid>
                        <Grid item >
                        <Button color="primary" variant={"contained"} disabled={false} style={{marginRight: '32px'}}
                            onClick={() => { this.updateAccountWithVerificationComplete(); }}>
                            Close
                        </Button> 
                        </Grid>
                      </Grid>
                        
                    </Grid>
                  </React.Fragment>
                  }
                  

                </Grid>

              </Grid>  
              <Dialog open={this.state.nameUpdateOpen} onClose={() => this.handleNameUpdateDialogClose()}>
              <DialogTitle>Confirm the exact name on your ID</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  We verify your identity using your government ID using an automated, online, secure system to preserve your privacy. Confirm this name <strong>exactly matches</strong> the name on the government ID you’ll use to verify your identity.
                </DialogContentText>
                  <Grid container spacing={2} justifyContent="space-between" style={{marginTop: '16px'}}>
                    <Grid item xs={12} sm={6}>
                      <TextField autoFocus data-recording-ignore="mask"
                                        id="ufirst-name" label="First name"
                                        value={ this.state.uFirstName }
                                        onChange={ (e) => this.setState({ uFirstName: e.target.value }) }
                                        inputProps={{ maxLength: 32 }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField data-recording-ignore="mask"
                                        id="ulast-name" label="Last name"
                                        value={ this.state.uLastName }
                                        onChange={ (e) => this.setState({ uLastName: e.target.value }) }
                                        inputProps={{ maxLength: 32 }} />
                    </Grid>

                  </Grid>
              </DialogContent>
              <DialogActions>
                <Button color="primary" variant={"outlined"} onClick={() => this.handleNameUpdateDialogClose()}>Cancel</Button>
                {!this.state.updateNameSpinner &&
                  <Button color="primary" variant={"contained"}  onClick={() => this.openNameUpdateDialogComplete()}>Proceed with verification</Button>
                }
                {this.state.updateNameSpinner &&
                  <Button disabled={true} color="primary" variant="outlined" >
                    <SavingSpinner/>
                  </Button> 
                }
              </DialogActions>
              </Dialog>
            </div>
  
          </Paper>

      );  
  
        }
      } else {
        return null;
      }


  }
}

export default withStyles(styleSheet)(AccountActivationSteps);